import React, { useEffect } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import CustomModal from "../../../../custom/modal/customModal";
import Select from "react-select"; // Import React Select
import { MasterApi } from "../../../../App/api/setting";
import * as Yup from "yup";

const validationSchema = Yup.object({
  vehicalType: Yup.object()
    .shape({
      value: Yup.string().required("Vehicle type is required"),
      label: Yup.string().required("Vehicle type is required"),
    })
    .nullable()
    .required("Vehicle type is required"),
  vehicalSubType: Yup.string()
    .max(50, "Must be 50 characters or less")
    .required("Vehicle subtype is required"),
});

const vehicleOptions = [
  { value: "Two-Wheeler", label: "Two-Wheeler" },
  { value: "Four-Wheeler", label: "Four-Wheeler" },
  { value: "Commercial", label: "Commercial" },
];

const AddVehicalModal = ({ isOpen, onClose, data, fetchAllData }) => {
  // Initialize formik
  const formik = useFormik({
    initialValues: {
      vehicalType: null, // Store the selected vehicle type
      vehicalSubType: "", // Store vehicle subtype
    },
    validationSchema,
    onSubmit: async (values) => {
      const payload = {
        ...values,
        vehicalType: values.vehicalType.value, // Send only the vehicle type value
      };
      // console.log("Form data", payload);

      try {
        if (data?._id) {
          const res = await MasterApi.master.updateVehicle(data?._id, payload);
          // console.log("res", res);
          toast.success("Updated vehicle details successfully");
          fetchAllData();
        } else {
          const res = await MasterApi.master.createVehicle(payload);
          toast.success("Created vehicle details successfully");
          fetchAllData();
          // console.log("res", res);
        }
      } catch (err) {
        // console.log(err);
      }

      handleClose(); // Close the modal after form submission
    },
  });

  // Update formik values when the data prop changes
  useEffect(() => {
    if (data) {
      formik.setValues({
        vehicalType: data?.vehicalType
          ? vehicleOptions.find((option) => option.value === data.vehicalType)
          : null,
        vehicalSubType: data?.vehicalSubType || "",
      });
    }
  }, [data, isOpen]);

  const handleClose = () => {
    formik.resetForm(); // Reset the form when closing
    onClose();
  };

  useEffect(() => {
    if (!isOpen) {
      formik.resetForm(); // Reset the form when the modal is closed
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Add Vehicle Details"
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">
        <div className="mb-4">
          <label className="block text-gray-700">Vehicle Type</label>
          <Select
            name="vehicalType"
            options={vehicleOptions}
            value={formik.values.vehicalType}
            onChange={(selectedOption) =>
              formik.setFieldValue("vehicalType", selectedOption)
            }
            onBlur={formik.handleBlur}
            className="mt-1"
          />
          {formik.touched.vehicalType && formik.errors.vehicalType && (
            <p className="text-red-500 text-sm mt-1">
              {formik.errors.vehicalType.label}
            </p>
          )}
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Vehicle Subtype</label>
          <input
            type="text"
            name="vehicalSubType"
            value={formik.values.vehicalSubType}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className={`mt-1 p-2 block w-full border ${
              formik.touched.vehicalSubType && formik.errors.vehicalSubType
                ? "border-red-500"
                : "border-gray-300"
            } rounded-md shadow-sm focus:ring focus:ring-opacity-50`}
          />
          {formik.touched.vehicalSubType && formik.errors.vehicalSubType && (
            <p className="text-red-500 text-sm mt-1">
              {formik.errors.vehicalSubType}
            </p>
          )}
        </div>

        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={handleClose}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="bg-[#e34e4e] text-white px-4 py-2 rounded hover:bg-blue-600"
          >
            Save
          </button>
        </div>
      </form>
    </CustomModal>
  );
};

export default AddVehicalModal;
